var exports = {
  "kL": "xcc377c0b--81f0da--container",
  "su": "xcc377c0b--81f0da--icon-wrapper",
  "h_": "xcc377c0b--81f0da--description",
  "DD": "xcc377c0b--81f0da--title",
  "VA": "xcc377c0b--81f0da--subtitle",
};

module.exports = exports;
